<template>
  <b-modal
    v-model="model"
    centered
    :title="editing ? 'Edit ' + titleType : 'Add ' + titleType"
    modal-class="modal-bb-squared"
    hide-footer
  >
    <template slot="default">
      <form @submit.prevent="submit">
        <FormItem
          label="Company name"
          invalid-message="Please enter name"
          :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
          required
        >
          <b-form-input
            v-model="form.name"
            :state="$v.form.name.$dirty ? !$v.form.name.$error : null"
            placeholder="Enter company name"
          />
        </FormItem>

        <FormItem
          label="Link to website or LinkedIn"
          invalid-message="Please enter correct URL"
          :state="$v.form.website.$dirty ? !$v.form.website.$error : null"
          required
        >
          <b-form-input
            v-model="form.website"
            :state="$v.form.website.$dirty ? !$v.form.website.$error : null"
            placeholder="Enter link"
          />
        </FormItem>

        <button class="btn btn-lg w-100 mb-16" type="submit">
          <span>{{ editing ? 'Save' : 'Create' }}</span>
        </button>
      </form>
    </template>
  </b-modal>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { urlValidator } from '@/validators/urlValidator'
import modalMixin from '@/mixins/modal'
import FormItem from '@/components/form/FormItem/index'

export default {
  name: 'CreateInvestorsAddInvestmentModal',
  components: {
    FormItem
  },
  mixins: [modalMixin, validationMixin],
  props: {
    name: String,
    editing: Object,
    titleType: {
      type: String,
      default: 'investment'
    }
  },
  data: () => ({
    isSending: false,
    form: {
      name: '',
      website: ''
    }
  }),
  watch: {
    name(value) {
      this.form.name = value
    },
    editing(value) {
      if (value) {
        this.form.name = value.name
        this.form.website = value.website
      }
    }
  },
  methods: {
    async submit() {
      this.$v.form.$touch()

      if (this.$v.form.$error) {
        return
      }

      this.$emit('submit', this.form)

      this.close()

      this.resetForm()
    },
    resetForm() {
      this.form.name = this.form.website = ''
      this.$v.form.$reset()
    }
  },
  validations: {
    form: {
      name: {
        required
      },
      website: {
        required,
        urlValidator
      }
    }
  }
}
</script>
